<template>
  <transition name="zt-slider-fade">
    <div v-if="isVisible" class="zt-slider-item relative w-full h-full" :class="{
      'zt-slide-active': isVisible,
    }">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ztSliderItem',
  inheritAttrs: false,
}
</script>

<style scoped lang="css" src="../../../../../src/styles/components/ztSlider.css"></style>
